import { scaleLinear } from 'd3'
// eslint-disable-next-line import/extensions
import { ballRadiusFeet } from './ball.js'

export const depthFrontOfPlateInches = 17
export const depthMidPlateInches = depthFrontOfPlateInches / 2
export const depthMidPlateFt = depthMidPlateInches / 12
export const depthFrontOfPlateFt = depthFrontOfPlateInches / 12

// // For a "relative" zone, we'll make a roughly average zone
// // This is Tom's average for a ~6ft player
export const topZone = 38.5 / 12
export const bottomZone = 19.5 / 12

export const plateWidthInches = 17
export const plateWidthFt = 17 / 12

// export const firstBaseZone = plateWidthFt / 2
// export const thirdBaseZone = plateWidthFt / -2

// export const topZoneFullyInZone = topZone - ballRadiusFeet
// export const bottomZoneFullyInZone = bottomZone + ballRadiusFeet

// export const firstBaseZoneFullyIn = firstBaseZone - ballRadiusFeet
// export const thirdBaseZoneFullyIn = thirdBaseZone + ballRadiusFeet

// // GENERIC OLD
export const topZoneOld = 3.5
export const bottomZoneOld = 1.5

// Takes a pitch and zone and "normalizes" it to a generic six foot ABS zone
export function getSixFootNormalized(
    px: number,
    pz: number,
    szTop: number,
    szBot: number,
    szWidthInches: number
) {
    return normalizeToZone(
        px,
        pz,
        szTop,
        szBot,
        szWidthInches,
        topZone,
        bottomZone,
        17
    )
}

// Makes everything work in SVG space taking into account strokes
export function getSVGRectPositioning(
    szTop: number,
    szBot: number,
    szWidth: number,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>,
    strokeWidth: number
) {
    const halfPlate = szWidth / 2
    // Handle pitcher perspective by assuming the canvas coords are always positive heading to the right
    const middle = xScale(0)
    const diff = Math.abs(xScale(halfPlate) - middle)
    const x = middle - diff + strokeWidth / 2
    const y = yScale(szTop) + strokeWidth / 2
    const width = Math.abs(xScale(halfPlate) - xScale(-halfPlate)) - strokeWidth
    const height = yScale(szBot) - yScale(szTop) - strokeWidth

    return { x, y, width, height }
}

// Takes a pitch with strike zone, and a target zone, and "normalizes" the pitch to the target zone
export function normalizeToZone(
    px: number,
    pz: number,
    szTop: number,
    szBot: number,
    szWidthInches: number,
    targetSzTop: number,
    targetSzBot: number,
    targetSzWidthInches: number
) {
    // export const topZone = 38.5 / 12
    // export const bottomZone = 19.5 / 12

    const targetPlateWidthFt = targetSzWidthInches / 12
    const targetFirstBaseZone = targetPlateWidthFt / 2
    const targetThirdBaseZone = targetPlateWidthFt / -2

    const topZoneFullyInZone = targetSzTop - ballRadiusFeet
    const bottomZoneFullyInZone = targetSzBot + ballRadiusFeet

    const firstBaseZoneFullyIn = targetFirstBaseZone - ballRadiusFeet
    const thirdBaseZoneFullyIn = targetThirdBaseZone + ballRadiusFeet

    const playerTopZoneFullyIn = szTop - ballRadiusFeet
    const playerBottomZoneFullyIn = szBot + ballRadiusFeet

    const fullyInUp = pz < playerTopZoneFullyIn
    const fullyInDown = pz > playerBottomZoneFullyIn
    const fullyInZ = fullyInUp && fullyInDown

    const halfPlate = szWidthInches / 12 / 2
    const playerFirstBaseZoneFullyIn = halfPlate - ballRadiusFeet
    const playerThirdBaseZoneFullyIn = -halfPlate + ballRadiusFeet

    const fullyInFirst = px < playerFirstBaseZoneFullyIn
    const fullyInThird = px > playerThirdBaseZoneFullyIn
    const fullyInX = fullyInFirst && fullyInThird

    let newX = px
    let newZ = pz

    if (fullyInX) {
        // Do some scaling
        // X axis is likely to be a noop, assuming the plate stays 17 inches
        const xScale = scaleLinear()
            .domain([playerThirdBaseZoneFullyIn, playerFirstBaseZoneFullyIn])
            .range([thirdBaseZoneFullyIn, firstBaseZoneFullyIn])

        newX = xScale(px)
    }

    if (fullyInZ) {
        const zScale = scaleLinear()
            .domain([playerBottomZoneFullyIn, playerTopZoneFullyIn])
            .range([bottomZoneFullyInZone, topZoneFullyInZone])

        newZ = zScale(pz)
    }

    if (!fullyInUp) {
        // translate
        const amountAboveZone = pz - playerTopZoneFullyIn
        newZ = topZoneFullyInZone + amountAboveZone
    }

    if (!fullyInDown) {
        // translate, I didn't really need to flip the signs, but my brain understands it better I think.
        const amountBelowZone = playerBottomZoneFullyIn - pz
        newZ = bottomZoneFullyInZone - amountBelowZone
    }

    if (!fullyInFirst) {
        // translate
        const amountOutsideZone = px - playerFirstBaseZoneFullyIn
        newX = firstBaseZoneFullyIn + amountOutsideZone
    }

    if (!fullyInThird) {
        // translate
        const amountOutsideZone = playerThirdBaseZoneFullyIn - px
        newX = thirdBaseZoneFullyIn - amountOutsideZone
    }

    if ((!fullyInUp && !fullyInDown) || (!fullyInFirst && !fullyInThird)) {
        console.error('SANITY CHECK FAILED')
        throw new Error('Sanity check failed')
    }

    return { x: newX, z: newZ }
}
